import URL from '../../url'
import Request from '../../request'

export const handleDisconnectService = content =>
    new Request(URL.API, URL.PAYMENT_DISCONNECTION).post(content)